import { useContext, useState, useEffect } from "react";
import { AppContext } from "../AppContext";
import { Button } from "@mantine/core";
import pause from "../assets/pause.png";
import continue2 from "../assets/continue2.png";
import quit2 from "../assets/quit2.png";

const PauseOverlay = ({ closeGame }) => {
  const { hidePauseOverlay, lockPointer } = useContext(AppContext);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="absolute z-10 flex h-full w-full flex-col items-center justify-center bg-black text-zinc-50">
      <img src={pause} alt="pause" className="my-32 w-80 max-w-[600px]" />
      <div className="flex flex-row gap-20">
        <img
          src={continue2}
          onClick={() => {
            hidePauseOverlay();
            lockPointer();
          }}
          alt="continue"
          className={`w-40 max-w-[200px] ${showButton ? "visible" : "invisible"}`}
        />
        <img
          src={quit2}
          onClick={() => {
            closeGame(false);
          }}
          alt="quit"
          className={`w-40 max-w-[200px] ${showButton ? "visible" : "invisible"}`}
        />
      </div>
    </div>
  );
};

export default PauseOverlay;
